import React, { useEffect, useRef, useState } from "react";
import { makeGet } from "@culturehq/client";
import { Loader, Panel, Table, Warning } from "@culturehq/components";

import { Trans } from "app/utils";
import ErrorMessage from "components/common/ErrorMessage";
import OrganizationAIUsageRow from "./settings/monitor-ai-usage/OrganizationAIUsageRow";
import { StateProps } from "./settings/monitor-ai-usage/MonitorAIUsageTypes";
import DateRangeFilter from "./ExternalAnalytics/DateRangeFilter";

import styles from "./MonitorAIUsage.module.scss";

const MonitorAIUsage = () => {
  const isMounted = useRef<boolean>();
  const [{ loading, organizations, error, range }, setState] = useState<StateProps>({
    loading: false,
    range: { startDate: undefined, endDate: undefined },
    organizations: [],
    error: undefined
  });

  const handleState = (
    newProps: Partial<StateProps>
  ) => setState(prev => ({ ...prev, ...newProps }));

  const handleFetch = () => {
    makeGet("/ai_usage_monitor", range as any).then(
      ({ organizations }: any) => isMounted.current
      && handleState({ organizations, loading: false }));
  };

  const handleFilterChange = (param: keyof StateProps["range"], value: any) => setState(prev => ({
    ...prev,
    range: {
      ...prev.range,
      [param]: value
    }
  }));

  useEffect(() => {
    isMounted.current = true;
    handleState({ loading: true });
    handleFetch();

    return () => {
      isMounted.current = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range]);

  return (
    <div className={styles.MonitorAIUsage}>
      <DateRangeFilter onChange={handleFilterChange} />
      <Panel limitWidth className={styles.Panel}>
        <Panel.Heading primary>Monitor AI Usage</Panel.Heading>
        <Panel.Body className="ManageUsers">
          {error && <ErrorMessage error={error} />}

          <Loader loading={loading}>
            <Table className="no-scrollbar">
              <thead>
                <tr>
                  <th><Trans>Organization</Trans></th>
                  <th><Trans>Token Usage</Trans></th>
                </tr>
              </thead>
              <tbody>
                {organizations.map(organization => (
                  <OrganizationAIUsageRow
                    key={organization.id}
                    organization={organization}
                  />
                ))}
              </tbody>
            </Table>

            {!organizations.length && (
              <Warning><Trans>No results to show.</Trans></Warning>
            )}
          </Loader>
        </Panel.Body>
      </Panel>
    </div>
  );
};

export default MonitorAIUsage;
